export default __webpack_public_path__ + "static/media/case-study4.dea3927b.webp";